import * as React from 'react';

// SVG plano (no createIcon) para conservar el `fill="none"` del root: las formas
// con solo `stroke` se rellenarían de currentColor con createIcon.
type IconProps = React.SVGProps<SVGSVGElement>;

export function ProductosIcon(props: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 34 34'
      fill='none'
      width={24}
      height={24}
      {...props}>
      <rect x='4' y='14' width='8' height='15' rx='3' fill='#5CC9BA' />
      <rect x='5.5' y='10' width='5' height='4' rx='1' fill='#3DA89A' />
      <path d='M4 23H12' stroke='white' strokeWidth='1.5' />
      <path
        d='M22 8C22 6.3 23.3 5 25 5C26.7 5 28 6.3 28 8'
        stroke='#3885FE'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <rect x='18' y='9' width='13' height='18' rx='2.5' fill='#3885FE' />
      <path
        d='M18 22H31V24.5C31 25.9 29.9 27 28.5 27H20.5C19.1 27 18 25.9 18 24.5V22Z'
        fill='#0E3663'
      />
      <path d='M16 16L24 20L16 24L8 20L16 16Z' fill='#FFD25C' />
      <path d='M8 20L16 24V31L8 27V20Z' fill='#FFB800' />
      <path d='M16 24L24 20V27L16 31V24Z' fill='#E5A000' />
      <path
        d='M14.5 16.7L17.5 18.2V30.2L14.5 28.7V16.7Z'
        fill='white'
        fillOpacity='0.8'
      />
    </svg>
  );
}
